import React from 'react';
import HeaderHelp from './HeaderHelp';
import PropTypes from 'prop-types';
import LoadingContainer from '../../Page/LoadingContainer';
import SMCPageErrorBoundary from '../../../pages/ErrorBoundaries/SMCPageErrorBoundary';
import BackButton from '../backButton/BackButton'
import {useDispatch} from 'react-redux'
import {setShowBackButton } from '../../../store/actions/view.actions'
function SMCPage({
    helpId,
    loading,
    children
}) {
    const dispatch = useDispatch();
    React.useEffect(()=>{dispatch(setShowBackButton(false,""))},[dispatch]);
    return (
        <SMCPageErrorBoundary>
            <LoadingContainer loading={loading}>
                <table style={{ width: "100%", height: "100%", border: 0 }} cellSpacing="0" cellPadding="0">
                    <tbody>
                        <tr style={{ height: "100%" }}>
                            {/* Side bar */}
                            <td style={{ width: 10, height: "100%" }}>
                                <table style={{ height: "100%", width: 20, border: 0 }} cellPadding="0" cellSpacing="0">
                                    <tbody>
                                        <tr style={{ height: 45 }}>
                                            <td />
                                        </tr>
                                        <tr>
                                            <td />
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                            {/* End side-bar */}
                            <td style={{ width: "100%", verticalAlign: "top" }}>
                                <table style={{width: "100%", border: 0 }} cellPadding="0" cellSpacing="0" className="BodyMain">
                                    <tbody>
                                        <tr style={{ height: 20 }}>
                                            <td>
                                                <HeaderHelp helpId={helpId} />
                                                <BackButton/>
                                            </td>
                                        </tr>
                                        <tr style={{ verticalAlign: "top" }}>
                                            <td>
                                                { children }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </LoadingContainer>
        </SMCPageErrorBoundary>
    );
}

SMCPage.propTypes = {
    helpId: PropTypes.array,
    children: PropTypes.node.isRequired
}

export default SMCPage;
